export default "__VITE_ASSET__CQR8Wi$R__"